// Relative base URL on purpose: frontend and backend are same-origin behind
// nginx, so no domain is baked into the bundle and a domain change needs no
// rebuild. Same decision as the tenant frontends (Phase 3).
const BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const TOKEN_KEY = 'slb_dashboard_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    // Token expired or rejected. Clear it so the app returns to login rather
    // than looping on failed requests with a dead credential.
    clearToken();
    const err = new Error('Session expired. Please sign in again.');
    err.status = 401;
    throw err;
  }

  let body = null;
  try {
    body = await res.json();
  } catch {
    body = null;
  }

  if (!res.ok) {
    // Surface the backend's own message when it sends one — a generic
    // "Request failed" hides the actual reason from the user.
    throw new Error(body?.message || `Request failed (${res.status})`);
  }
  return body;
}

export const login = (username, password) =>
  request('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) });

export const fetchSummary = () => request('/stats/summary');

// v2 — the landing screen in one call, and one call per drill-down. Detail is
// fetched only when a tile is opened; loading five tables to render six tiles
// would make the screen slower than the question it answers.
export const fetchOverview = () => request('/overview');
export const fetchReceivables = () => request('/detail/receivables');
export const fetchPayables = () => request('/detail/payables');
export const fetchAdvances = () => request('/detail/advances');
export const fetchStock = () => request('/detail/stock');
export const fetchCustomerSales = (month) =>
  request(`/detail/customer-sales${month ? `?month=${encodeURIComponent(month)}` : ''}`);
export const fetchWaste = () => request('/detail/waste');
export const fetchEfficiencyGain = () => request('/detail/efficiency-gain');
